import Select from '~/components/Select';
import { useFormsQuery } from '~/lib/Queries';
import { useEffect } from 'react';

const AdminSelectForm = ({ formId, setFormId, eventTypeId }) => {
    const { data: allFormsData } = useFormsQuery();
    const formOptions = {
        0: 'Default',
    };

    (allFormsData || [])
        .filter(form => form.is_booking)
        .filter(form => (form.event_type_ids || []).indexOf(eventTypeId) > -1)
        .forEach(form => {
            formOptions[`${form.id} `] =
                `${form.name} ${form.is_default_booking ? '(Default Booking Form)' : ''}`;
        });

    useEffect(() => {
        setFormId(0);
    }, [allFormsData]);

    return (
        <>
            {Object.keys(formOptions).length > 1 && (
                <div className="">
                    <Select
                        options={formOptions}
                        value={formId}
                        onChange={setFormId}
                        label="Form"
                        inputClassName="w-full"
                    />
                </div>
            )}
        </>
    );
};

export default AdminSelectForm;
